export const showBannerForPeriod = (startDate: string, endDate: string) => {
    const startDateConstructed = new Date(formatDate(startDate));
    const endDateConstructed = new Date(formatDate(endDate));

    if (startDateConstructed > endDateConstructed) return false;

    const todayDate = new Date();

    if (todayDate >= startDateConstructed && todayDate < endDateConstructed)
      return true;
    else return false;
};

export const formatDate = (date: string) => date.split('/').reverse().join('/');

export const lowerCaseArrayInArrayOfObjects = (array, term) => {
    for (let i = 0; i < array.length; i++) {
      const keys = Object.keys(array[i]);

      for (let j = 0; j < keys.length; j++) {
        const key = keys[j];

        if (key === term) {
          for (let k = 0; k < array[i][key].length; k++) {
            array[i][key][k] = array[i][key][k].toLowerCase();
          }
        }
      }
    }

    return array;
};
